<template>
    <div class="login">
        <b-container>
            <b-row >
			    <b-col id="welcome" class="text-center">
                    <img src="img/logo.png" class="center-block" alt="EnergyDrive">
                </b-col>
             </b-row> 
             <b-row >
			    <br><hr>
             </b-row> 
             <b-row>   
                <b-col>
                    <form action="login" method="post">
						Username: <input v-model="username" type="text" name="username" class="form-control" required><br>
						Password: <input v-model="password" type="password" name="password" class="form-control" required>
						<br>
						<input type="submit" value="Login" @click="handleSubmit" style="width:100%;">
					</form>
                </b-col>    
                
			
		    </b-row>    
        </b-container>

    </div>    
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import jwt_decode from 'jwt-decode';



export default {
  name: 'login',
  data() {
      return {
          username : "",
          password : ""
      }
  },
  
    methods : {
        handleSubmit(e){
            console.log("Clicked submit");
            //localStorage.setItem('ticketCopURL',"https://energydrive.dnsalias.com/ticketcopapi");
            //localStorage.setItem('ticketCopURL',"https://energydrive.dnsalias.com/ticketcop_dev");
            if ( process.env.NODE_ENV == "development" )
            {
                localStorage.setItem('ticketCopURL',"https://energydrive.dnsalias.com/ticketcop_dev");
            }
            else
            {
                localStorage.setItem('ticketCopFrontend',"https://energydrive.dnsalias.com/ticketcop");
                localStorage.setItem('ticketCopURL',"https://energydrive.dnsalias.com/ticketcopapi");
            }
            e.preventDefault()
            if (this.password.length > 0) {
                console.log("Makign post");
                this.$http.post(localStorage.getItem('ticketCopURL') +'/login', {
                    username: this.username,
                    password: this.password
                })
                .then(response => {
                    console.log("Response after login");
                    console.log(response.data);
                    var decoded = jwt_decode(response.data.token);
                     console.log("Token object decoded");
                    console.log(decoded);
                    localStorage.setItem('jwt',response.data.token);
                    localStorage.setItem('employee',decoded.employee);
                    localStorage.setItem('idemployee',decoded.idEmployee);
                   


                    console.log( localStorage.getItem('employee') );
                    console.log( localStorage.getItem('jwt') );
                    console.log( localStorage.getItem('idemployee') );
                    let userID = "1."+localStorage.getItem('idemployee');
                    console.log("Setting google user ID");
                    this.$ga.set("userId", userID);
                    console.log(this);
                    // create permission token
                  


                    
                    //localStorage.setItem('ticketCopURL',"ticketcop_dev");
                    //localStorage.setItem('employeeEmail',response.data.userDetails.Email);
                    //localStorage.setItem('employeeTelegramID',response.data.userDetails.idTelegram);


                    if (localStorage.getItem('jwt') != null){
                        console.log( localStorage.getItem('jwt') );
                        this.$emit('loggedIn')
                        if(this.$route.params.nextUrl != null){
                            this.$router.push(this.$route.params.nextUrl)
                        }
                        else {
                            let employee = localStorage.getItem('employee');
                            console.log(employee);
                            this.$router.push({
                                name: 'home'
                                 
                              
                            })
                             
                        }

                    }
                    else
                    {
                        console.log("Could not do local storage");

                    }

                })
                .catch(function (error) {
                    console.error(error);
                });
            }
        }
    }
  //components: {
  //  HelloWorld
 // }
}
</script>
